import { StructureIndex } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { getAdvPersoDataFromElement } from 'editor/src/store/plugins/utils/advPersoUtils';

import { RootState } from '../..';
import getMediaElement from '../selector/getMediaElement';
import { getLinkedCollectionElements } from '../util/collectionLink';
import hasElementNameClash from '../util/hasElementNameClash';

import updateMediaElementOperation, { MediaUpdateActionName } from './updateMediaElementOperation';

const updateMediaElementNameOperation =
  (elementAddress: StructureIndex, name: string) => (dispatch: ThunkDispatch, getState: () => RootState) => {
    const state = getState();
    const element = getMediaElement(state, elementAddress);
    if (!element || !state.design.designData) {
      return false;
    }

    const linkGroupId = getAdvPersoDataFromElement(element)?.linkGroupId;
    const linkedElements = linkGroupId ? getLinkedCollectionElements(state.design.designData, linkGroupId) : [];

    // Re-saving the element's current name introduces no new collision — always allowed
    // (even if an unrelated element elsewhere already carries the same name).
    const isNameUnchanged = name === element.name;

    if (!isNameUnchanged && hasElementNameClash(state.design.designData, element, name)) {
      return false;
    }

    if (linkedElements.length > 0) {
      linkedElements.forEach((linked) => {
        dispatch(updateMediaElementOperation(linked.address, { name }, MediaUpdateActionName.RENAMED));
      });
    } else {
      dispatch(updateMediaElementOperation(elementAddress, { name }, MediaUpdateActionName.RENAMED));
    }

    return true;
  };

export default updateMediaElementNameOperation;
